<mat-form-field [formGroup]="form" appearance="outline" color="primary" class="datepicker">
  <mat-label>{{this.label}}</mat-label>
  <input matInput [readonly]="this.readonly" [matDatepicker]="picker" [id]="this.key" [formControlName]="this.key"
      [name]="this.key" [value]="this.value" [disabled]="this.disabled || false" [errorStateMatcher]="matcher">
  <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="this.isDatePickerDisabled()" [id]="this.key" />
  <mat-datepicker #picker [disabled]="this.isDatePickerDisabled()">
    @if (shouldShowActions()) {
      <mat-datepicker-actions>
        <button mat-button matDatepickerCancel i18n>Cancel</button>
        <button mat-raised-button matDatepickerApply i18n>Apply</button>
      </mat-datepicker-actions>
    }
  </mat-datepicker>
</mat-form-field>